import moment from 'moment';
import { expandObject, flattenObject } from '../../framework/App/AppUtils';
import _ from 'lodash';
import {LEGAL_MIN_AGE, LEGAL_MAX_AGE, SPECIAL_AGE_STATES} from './FormElementUtilsConstants';
import { scrollToError } from '../../framework/App/SkeletonPage/SkeletonPageActions';

export const isEmpty = (msg) => (value) => {
    if (_.trim(value).length === 0) {
        return {
            msg,
            className: 'hasError'
        };
    }
};

/**
 *
 * @param msg Plain text message.
 * @param msgKey Locale property key to pass to intl.formatMessage or FormattedMessage.
 * @returns {{msg: *, msgKey: *, className: string}}
 */
export const getValidationError = (msg, msgKey) => {
    if (msg || msgKey) {
        return {
            msg,
            msgKey,
            className: 'hasError'
        };
    }
};

/**
 * Validate Date of Birth
 * Validate if date is a valid date w/ a valid day, month and year.
 * Customers should not be allowed to apply for credit if they are < 18 years old due to legal restrictions.
 * Residents of AL and NE should not be allowed to apply for credit if they are < 19 years old due to legal restrictions.
 * but rather a general invalid date category.
 * @param dateValue
 * @param dateFormat
 * @param underAgeMessage
 * @param usState
 * @param errorMessage
 * @returns undefined | {{msg: *, errorType: string, className: string}}
 */
export const isValidDateOfBirth = (dateValue, dateFormat, underAgeMsg, errorMsg, usState) => {
    const dobMoment = moment(dateValue, dateFormat, true);
    const dobValid = dobMoment.isValid();
    const genericError = {
        msg: errorMsg,
        errorType: 'generic',
        className: 'hasError'
    };
    if (!dobValid) {
        return genericError;
    }
    const userAge = moment().diff(dobMoment, 'years');
    let legalMinimumAge = LEGAL_MIN_AGE;

    if (_.has(SPECIAL_AGE_STATES, usState)) {
        legalMinimumAge = SPECIAL_AGE_STATES[usState];
    }

    if (userAge < legalMinimumAge) {
        return {
            msg: underAgeMsg,
            errorType: 'underAge',
            className: 'hasError'
        };
    } else if (userAge > LEGAL_MAX_AGE) {
        return genericError;
    }
};

// Format errors and resolve error messages
export const processSubmissionErrors = (errors, localePrefix = '') => {
    const obj = (
        Object
            .keys(errors)
            .reduce((acc, errorKey) => {
                acc[errorKey] = getValidationError(undefined, `${localePrefix ? localePrefix + '.' : ''}${errorKey}.${errors[errorKey].msg}`);
                return acc;
            }, {})
    );
    return expandObject(obj);
};

export function handleSubmitFail(errors, dispatch) {
    const flattenedErrors = flattenObject(errors, '', ['msg', 'className']); // Flatten object to support FormSections
    const errorEl = document.querySelector(
        Object.keys(flattenedErrors).map(fieldName => `[name="${fieldName}"]`).join(',')
    );

    if (errorEl) {
        dispatch(scrollToError(errorEl));
    }
}
